import axios from "@/plugins/axios";

export const state = () => ({
  customers: [],
  customers_types: [],
  customers_groups: [],
  sales: [],
});

export const mutations = {
  SET_CUSTOMERS(state, payload) {
    state.customers = payload;
  },
  SET_CUSTOMER_TYPES(state, payload) {
    state.customers_types = payload;
  },
  SET_CUSTOMER_GROUPS(state, payload) {
    state.customers_groups = payload;
  },
  SET_CUSTOMER_SALES(state, payload) {
    state.sales = payload;
  },
};

export const actions = {
  async search({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("pos/customers", payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async fetchUser({}, customerId) {
    return new Promise((resolve, reject) => {
      axios
        .get("pos/customers/" + customerId)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async CreateCustomer({}, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("pos/customers", payload)
        .then((res) => {
          resolve(res);
          dispatch("search");
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async UpdateCustomer({}, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .patch("pos/customers/" + id, payload)
        .then((res) => {
          resolve(res);
          dispatch("search");
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async fetchCustomers({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get("pos/customers")
        .then((res) => {
          commit("SET_CUSTOMERS", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async fetchCustomerTypes({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get("pos/customer-types")
        .then((res) => {
          commit("SET_CUSTOMER_TYPES", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async fetchCustomerGroups({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get("pos/customer-groups")
        .then((res) => {
          commit("SET_CUSTOMER_GROUPS", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async fetchCustomerSales({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `customers/${payload.id}/sales?shop=${payload.shop}&saleType=${
            payload.saleType
          }&start=&end=&paymentStatus=${
            payload.paymentStatus
          }&page=${1}&size=${20}&query=${payload.query}`
        )
        .then((res) => {
          if (res.data.data) {
            commit("SET_CUSTOMER_SALES", res.data.data);
            resolve(res.data.data);
          } else {
            let data = [];
            commit("SET_CUSTOMER_SALES", data);
            resolve(data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const getters = {
  GetCustomerTypes: (state) => state.customers_types,
  GetCustomerGroups: (state) => state.customers_groups,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
